export const encodeImageFileAsURL = (file) =>
	new Promise((resolve, reject) => {
		var fileReader = new FileReader();

		fileReader.onload = (fileLoadedEvent) =>
			resolve(fileLoadedEvent.target.result);

		fileReader.onerror = () => reject("Invalid Image");

		fileReader.readAsDataURL(file);
	});

export const safeEncodeImageFileAsURL = (file) => {
	if (!file.type.includes("image"))
		return Promise.resolve(URL.createObjectURL(file));
	return encodeImageFileAsURL(file);
};

export const checkIfDataURIIsPdf = (dataURI) => {
	if (!dataURI) return false;
	if (dataURI.endsWith(".pdf")) return true;
	const parsedDataURI = dataURI.split(",");
	if (parsedDataURI.length < 2) return false;
	const base64 = dataURI.split(",")[1];
	const binary = atob(base64);
	return binary.slice(0, 4) === "%PDF";
};
